import { render } from "./BarChart3D.vue?vue&type=template&id=2a97d56e&scoped=true"
import script from "./BarChart3D.vue?vue&type=script&lang=js"
export * from "./BarChart3D.vue?vue&type=script&lang=js"

import "./BarChart3D.vue?vue&type=style&index=0&id=2a97d56e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a97d56e"]])

export default __exports__